<template>
  <v-slide-y-transition group tag="div" class="loan-container">
    <h3 key="title" v-if="ready" class="text-center font-weight-black pt-2">대출 상세</h3>
    <div key="content" class="content">
      <v-slide-y-transition>
        <SectionWrapper v-if="isInvestingShow" title="대출 모집 현황">
          <InvestingProgressCircular :loan="loan" :loanUuid="uuid" class="mb-6" />
          <LoanContractButton class="mt-6" :uuid="loan.uuid" />
        </SectionWrapper>
      </v-slide-y-transition>

      <SectionWrapper v-if="loan" title="대출 정보">
        <LoanSummary :loan="loan" :request="request" />
      </SectionWrapper>

      <SectionWrapper v-if="isRepaymentShow" title="상환 내역">
        <Repayments :loan="uuid"></Repayments>
      </SectionWrapper>
    </div>
  </v-slide-y-transition>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {
    InvestingProgressCircular: () => import('@/components/loan/InvestingProgressCircular.vue'),
    SectionWrapper: () => import('@/components/loans-request/detail/SectionWrapper.vue'),
    LoanSummary: () => import('@/components/loan/detail/LoanSummary.vue'),
    LoanContractButton: () => import('@/components/loan/LoanContractButton.vue'),
    Repayments: () => import('@/components/loan/Repayments.vue'),
  },
  data() {
    return {
      uuid: null,
      loan: null,
      request: null,
      ready: false,
    }
  },
  computed: {
    isInvestingShow() {
      if (['investing', 'invested', 'executing'].includes(this.loan?.status)) {
        return true
      }
      return false
    },
    isRepaymentShow() {
      if (['executed', 'finished'].includes(this.loan?.status)) {
        return true
      }
      return false
    },
  },
  mounted() {
    this.ready = true
  },
  async created() {
    this.uuid = this.$route.params.uuid
    const [loan, { data: request }] = await Promise.all([
      this.getLoansDetail(this.uuid),
      this.$defaultApi.getLoansRequestByLoan(this.uuid),
    ])
    this.loan = loan
    this.request = request
  },
  methods: {
    ...mapActions('loan', ['getLoansDetail', 'getInvestingAmount']),
  },
}
</script>